<div class="overflow-x-auto">
  <table class="w-full border-collapse">
    <thead>
    <tr>
      <th class="w-1/4 text-left min-w-[15rem] pb-1">
        @if (title()) {
        <h6 class="text-base soft-overline pb-0 !mb-0">{{ title() }}</h6>
        }
      </th>
      <th class="w-1/4 text-right px-2 pb-1 text-sm">Kilo</th>
      <th class="w-1/4 text-right px-2 pb-1 text-sm">FE %</th>
      <th class="w-1/4 text-right px-2 pb-1 text-sm">FE</th>
    </tr>
    </thead>
    <tbody class="border">
    @for (zeile of calculatedZeilen(); track zeile.index; let idx = $index) {
    <tr>
      <td class="bg-surface-secondary border p-2 min-w-[14rem]">{{ zeile.zeile?.artikel?.bezeichnung ?? '' }}</td>
      <td class="p-0 border min-w-[5rem]"><soft-number-input placeholder="0,00" class="border-none" textAlign="right" [value]="zeile.zeile?.kg ?? null" (valueChange)="updateZeile(zeile.zeile, 'kg', idx, $event)"></soft-number-input></td>
      <td class="p-0 border min-w-[5rem]"><soft-number-input placeholder="0,00 %" class="border-none" textAlign="right" [value]="zeile.zeile?.fetteinheitenProz ?? null" (valueChange)="updateZeile(zeile.zeile, 'fetteinheitenProz', idx, $event)"></soft-number-input></td>
      <td class="p-0 px-2 min-w-[5rem] border bg-surface-secondary !text-right">{{ (zeile?.result || 0) | number:'1.2-2' }}</td>
    </tr>
    }
    </tbody>
    <tfoot>
    <tr>
      <td class="border-t px-2 pt-2 mt-2 border-solid font-semibold" colspan="3">Summe</td>
      <td class="border-t px-2 pt-2 mt-2 border-solid font-semibold !text-right">{{ sum() | number:'1.2-2' }}</td>
    </tr>
    </tfoot>
  </table>
</div>
